import { useComputed } from "@suse-o11y/signal";
import React from "react";

import { type VariantProps, cv } from "~/tools/class-variance";

import { useTableContext } from "./_context";
import styles from "./_table.module.css";

const variants = cv(styles.tableStickyCells, {
	variants: {
		direction: {
			left: styles.left,
			right: styles.right,
		},

		sticking: {
			true: styles.sticking,
		},
	},
});

export interface TableStickyCellsProps extends VariantProps<typeof variants>, React.HTMLAttributes<HTMLDivElement> {
	/**
	 * The number of sticky cells.
	 *
	 * @default 1
	 */
	span?: number;
}

export const TableStickyCells = React.forwardRef<HTMLDivElement, TableStickyCellsProps>(
	({ className, direction: directionFromProps, span = 1, style, ...props }, ref) => {
		const direction = directionFromProps ?? "left";

		const { overflowState } = useTableContext();

		const sticking = useComputed(
			(monitor) => {
				const overflow = overflowState.read(monitor);

				return direction === "left" ? overflow?.left : overflow?.right;
			},
			[overflowState, direction],
		);

		return (
			<div
				className={variants({ direction, className, sticking })}
				ref={ref}
				style={{
					...style,
					gridColumn: `span ${span} / span ${span}`,
				}}
				{...props}
			/>
		);
	},
);
